import React from "react";
import PropTypes from "prop-types";
import { Tabbar as TabbarDHX } from "dhx-suite";
import "../../../dhtmlx/codebase/suite.css";

class TabbarEvents extends React.Component {
  constructor(props) {
		super(props);
		this.state = {
			event: "",
			id: "",
		};
	}

	componentDidMount() {
		this.tabbar = new TabbarDHX(this.el, {
			mode: "top",
			closable: false,
			tabAlign: "center",
			views: this.props.view,
		});
		this.tabbar.events.on("change",(()=>{this.props.onChange()}));
	}
	componentWillUnmount() {
		this.tabbar && this.tabbar.destructor();
	}
  
	render() {
		return (
			<div>
				<div  ref={el => (this.el = el)}></div>
			</div>
		);
	}
}

TabbarEvents.propTypes = {
	mode: PropTypes.oneOf(["top", "bottom", "left", "right"]),
	view: PropTypes.arrayOf(PropTypes.object),
	closable: PropTypes.bool || PropTypes.arrayOf(PropTypes.string),
	disabled: PropTypes.string || PropTypes.arrayOf(PropTypes.string),
	noContent: PropTypes.bool,
	tabWidth: PropTypes.number || PropTypes.string,
	tabHeight: PropTypes.number || PropTypes.string,
	css: PropTypes.string,
	activeTab: PropTypes.string,
	tabAutoWidth: PropTypes.bool,
	tabAutoHeight: PropTypes.bool,
	tabAlign: PropTypes.oneOf(["left", "start", "center", "middle", "right", "end"]),
  onChange: PropTypes.func
};

export default TabbarEvents;